import { BigNumber } from 'ethers';
import { formatEther, formatUnits, parseEther, parseUnits } from 'ethers/lib/utils';
import { config } from '../../config/config';
import { OpenPositionParamsStruct } from '../../config/contracts/typechain/ITradeManager';

const generateOpenPositionLog = (
    userFee: BigNumber,
    decimals: number,
    params: OpenPositionParamsStruct
) => {
    const leverage = BigNumber.from(params.leverage)
        .div(config.leverageMultiplier)
        .toString();

    const margin = formatUnits(
        BigNumber.from(params.margin)
            .mul(parseUnits('1', decimals))
            .div(
                parseUnits('1', decimals).add(
                    parseUnits(leverage, decimals).mul(userFee).div(100_00)
                )
            ),
        decimals
    );

    const volume = formatUnits(
        BigNumber.from(leverage).mul(parseUnits(margin, decimals)),
        decimals
    );

    const fees = formatEther(parseEther(volume).mul(userFee).div(100_00));

    return { leverage, margin, volume, fees };
};

export default generateOpenPositionLog;
